function decodeJwtPayload(token: string): Record<string, unknown> | null {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return null;
        const payload = parts[1];
        if (!payload) return null;
        const base64 = payload
            .replace(/-/g, '+')
            .replace(/_/g, '/')
            .padEnd(payload.length + ((4 - (payload.length % 4)) % 4), '=');
        const jsonStr = atob(base64);
        return JSON.parse(jsonStr) as Record<string, unknown>;
    } catch {
        return null;
    }
}

/**
 * Extract the user UUID from a JWT service token without any library dependencies.
 * Works in both browser and Cloudflare Worker environments.
 */
export function extractUserUuid(serviceToken: string): string | null {
    const payload = decodeJwtPayload(serviceToken);
    if (!payload) return null;
    const userUuid = payload.user_uuid ?? payload.sub ?? (payload.ctx as Record<string, unknown>)?.user_uuid;
    return typeof userUuid === 'string' ? userUuid : null;
}
